import { render, staticRenderFns } from "./ModalImportarLicitacao.vue?vue&type=template&id=f9d0bbdc&scoped=true"
import script from "./ModalImportarLicitacao.vue?vue&type=script&lang=ts"
export * from "./ModalImportarLicitacao.vue?vue&type=script&lang=ts"
import style0 from "./ModalImportarLicitacao.vue?vue&type=style&index=0&id=f9d0bbdc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9d0bbdc",
  null
  
)

export default component.exports